import { reactive } from 'vue';

export class ReactiveModel {

    constructor(obj = null) {}

    setup() {}

    static createReactive(obj = null, prop = null) {
        const instance = new this(obj, prop);
        return instance.makeReactive();
    }

    makeReactive() {
        const reactiveInstance = reactive(this);
        reactiveInstance.setup();
        return reactiveInstance;
    }
}
